var _defs, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-a87a637b-3398-4e65-9493-7a15fbc87a50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72v0v-72v0h72v0v72v0z"
  })))), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Gruppe 3310"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Gruppe 3309"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Rechteck 2521")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-a87a637b-3398-4e65-9493-7a15fbc87a50)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5853"), /*#__PURE__*/React.createElement("path", {
    d: "M38.645,15.376v0l-5.533,-10.348c-0.828,-1.358 -2.794,-1.374 -3.644,-0.029c0,0 -16.445,34.904 -16.492,35.009c-1.275,2.801 -1.922,5.947 -1.747,9.263c0.535,10.096 8.95,18.36 19.054,18.716c11.259,0.397 20.512,-8.613 20.512,-19.786c0,-0.748 -0.042,-1.486 -0.123,-2.212",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-a87a637b-3398-4e65-9493-7a15fbc87a50)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5854"), /*#__PURE__*/React.createElement("path", {
    d: "M18.867,48.314c0.26,4.908 3.393,9.149 7.707,11.06",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-a87a637b-3398-4e65-9493-7a15fbc87a50)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5855"), /*#__PURE__*/React.createElement("path", {
    d: "M52.587,28.841c0.599,-0.364 1.139,-2.065 1.139,-2.065c4.374,2.793 3.047,12.477 -4.555,12.086c-3.71,-0.167 -5.195,-2.391 -5.781,-4.358c-0.49,-1.74 -0.422,-3.59 0.195,-5.289c2.229,-6.425 8.761,-6.934 8.761,-6.934c-2.216,4.19 0.241,6.559 0.241,6.56z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-a87a637b-3398-4e65-9493-7a15fbc87a50)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5856"), /*#__PURE__*/React.createElement("path", {
    d: "M41.536,20.602l-2.891,-5.226c-11.108,7.067 -7.737,31.574 11.566,30.584c9.42,-0.422 13.19,-6.05 14.678,-11.027c1.244,-4.403 1.071,-9.084 -0.494,-13.384c-5.659,-16.26 -22.246,-17.549 -22.246,-17.549c5.627,10.605 -0.613,16.6 -0.613,16.602z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelType2);
export default __webpack_public_path__ + "static/media/fuel-type-2.cf613269847cc4f5709e19bb3f8f3a83.svg";
export { ForwardRef as ReactComponent };